import React, { useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ProductForm = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const product = queryParams.get("product");
   const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const initialData = {
    name: "",
    mobile_no: "",
    email: "",
    city: "",
    message: "",
  };

  const [formData, setFormData] = useState(initialData);

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        `${BASE_URL}/api/product_pdf/create`,
        formData
      );
      setFormData(initialData);
      toast.success("Product Form submitted successfully");
      setIsSubmitted(true);
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    }
  };

  const downloadPDF = () => {
    const link = document.createElement("a");
    link.href = `/assets/pdf/${product}.pdf`;
    link.download = `${product}.pdf`;
    link.click();
  };

  return (
    // <div className="container mt-5">
    //   <h2 className="mb-4">Product Form</h2>

    //   <form onSubmit={handleSubmit}>
    //     <div className="row">
    //       <div className="col-md-4">
    //         <input
    //           type="text"
    //           name="name"
    //           placeholder="Name"
    //           className="form-control mb-3"
    //           value={formData.name}
    //           onChange={handleChange}
    //           required
    //         />

    //         <input
    //           type="text"
    //           name="mobile_no"
    //           maxLength={10}
    //           placeholder="Mobile Number"
    //           className="form-control mb-3"
    //           value={formData.mobile_no}
    //           onChange={handleChange}
    //           required
    //         />

    //         <input
    //           type="email"
    //           name="email"
    //           placeholder="Email"
    //           className="form-control mb-3"
    //           value={formData.email}
    //           onChange={handleChange}
    //           required
    //         />

    //         <input
    //           type="text"
    //           name="city"
    //           placeholder="City"
    //           className="form-control mb-3"
    //           value={formData.city}
    //           onChange={handleChange}
    //           required
    //         />

    //         <textarea
    //           name="message"
    //           placeholder="Message"
    //           className="form-control mb-3"
    //           rows="3"
    //           value={formData.message}
    //           onChange={handleChange}
    //           required
    //         />

    //         <button type="submit" className="btn btn-primary mb-3">
    //           Submit
    //         </button>
    //       </div>
    //     </div>
    //   </form>

    //   <button
    //     type="button"
    //     className="btn btn-success"
    //     onClick={downloadPDF}
    //     disabled={!isSubmitted}
    //     style={{ cursor: isSubmitted ? "pointer" : "not-allowed" }}
    //   >
    //     Download PDF
    //   </button>
    // </div>
    <div className="main-body">
      <div className="page-wrapper">
        <div className="row" style={{ marginBottom: "50px" }}>
          <div
            className="col-sm-6 product-box"
            style={{ padding: "60px 100px" }}
          >
            <div className="card">
              {/* Header */}
              <div className="card-header">
                <h5 style={{marginTop:"10px"}}>Product Form</h5>
              </div>

              {/* Body */}
              <div className="card-body">
                <form onSubmit={handleSubmit} id="productForm">
                  <div className="row">
                    {/* Name */}
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Name</label>
                        <input
                          type="text"
                          name="name"
                          className="form-control"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>

                    {/* Mobile */}
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Mobile Number</label>
                        <input
                          type="text"
                          name="mobile_no"
                          maxLength={10}
                          className="form-control"
                          value={formData.mobile_no}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {/* Email */}
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>

                    {/* City */}
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">City</label>
                        <input
                          type="text"
                          name="city"
                          className="form-control"
                          value={formData.city}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  {/* Message */}
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Message</label>
                      <textarea
                        name="message"
                        rows="3"
                        className="form-control"
                        value={formData.message}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                </form>
              </div>

              {/* Footer */}
              <div className="card-footer">
                <button
                  type="submit"
                  className="btn btn-primary me-2"
                  form="productForm"
                >
                  Submit
                </button>

                <button
                  type="button"
                  className="btn btn-success"
                  onClick={downloadPDF}
                  disabled={!isSubmitted}
                  style={{ cursor: isSubmitted ? "pointer" : "not-allowed" }}
                >
                  Download PDF
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductForm;
